import { warn } from "./debug";
export function findLocale(supportedLocales, locale) {
    if (supportedLocales.includes(locale)) {
        return locale;
    }
    for (var _i = 0, supportedLocales_1 = supportedLocales; _i < supportedLocales_1.length; _i++) {
        var localeToMatch = supportedLocales_1[_i];
        if (localeToMatch.includes(locale.split("-")[0])) {
            warn("Locale " + locale + " was not found. Using " + localeToMatch + " as a fallback");
            return localeToMatch;
        }
    }
    return undefined;
}
export function getBrowserLocale(supportedLocales, fallbackLocale) {
    var browserLocale;
    if (typeof window !== "undefined" && window.navigator) {
        var lang = (window.navigator.language ||
            // @ts-ignore
            window.navigator.userLanguage ||
            // @ts-ignore
            window.navigator.browserLanguage);
        if (lang) {
            browserLocale = findLocale(supportedLocales, lang);
        }
    }
    if (!browserLocale && !fallbackLocale) {
        browserLocale = findLocale(supportedLocales, "en");
    }
    return browserLocale || fallbackLocale || supportedLocales[0] || "en";
}
//# sourceMappingURL=locale.js.map